<template>
    <div class="roundImageContainer">
        <a href="" v-on:click.stop.prevent="$bus.$emit('activateProfileAvatarEditor')" class="roundImage roundImageOrigin" v-bind:style="{ 'background-image': 'url(' + currentImage + ')' }">
            <div class="blackHover"><i class="fa fa-camera"></i></div>									
        </a>
    </div>
</template>

<script>
	export default {
		name: 'profileAvatar',
		props: {
            image: String
        },
         data: function() {
        	return {
                currentImage: null
        	}
        },
        created: function() {
            var self = this;
            this.currentImage = this.image;
            this.$bus.$on('changedAvatar', ($event) => {
                this.currentImage = $event;
            });
        },
	}
</script>


// WEBPACK FOOTER //
// ProfileAvatar.vue?1486da68